module.exports = __webpack_public_path__ + "static/media/pdf.f8197fa6.svg";